import { yupResolver } from "@hookform/resolvers/yup";
import { Switch } from "antd";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import {
  useDetailCustomer,
  useLocationsByCustomer,
  useUpdateCustomer,
} from "hooks";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
import CustomerLocationTab from "./Location/CustomerLocationTab";
import { customerModeList } from "./utils";
import { getPhoneValidation } from "constants/validate";

const DetailCustomer = props => {
  const { isOpenModal, dataDetail, toggleModal, mode, handleViewCodeUse } =
    props;
  const { t } = useTranslation(["customer"]);
  const { addToast } = useToasts();
  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail

  const getInitDefaultValues = () => {
    return {
      code: "",
      name: "",
      phone: "",
      mail: "",
      note: "",
      source: "",
      info_contacts: [],
      is_noted: false,
    };
  };

  const getInitControlFields = () => {
    return {
      display: {
        code: false,
        name: false,
        phone: false,
        mail: false,
        note: false,
        source: false,
        is_noted: false,
        btn_save: false,
      },
      disabled: {
        code: false,
        name: false,
        phone: false,
        mail: false,
        note: false,
        source: false,
        is_noted: false,
      },
    };
  };
  const [controlFields, setControlFields] = useState(getInitControlFields);

  const schema = yup.object().shape({
    code: yup
      .string()
      .required(t("form.validate.required", { title: t("form.code") }))
      .max(250, t("form.validate.char_max", { max: 250 })),
    name: yup
      .string()
      .required(t("form.validate.required", { title: t("form.name") }))
      .max(250, t("form.validate.char_max", { max: 250 })),
    mail: yup.string().max(250, t("form.validate.char_max", { max: 250 })),
    note: yup.string().max(250, t("form.validate.char_max", { max: 250 })),
    phone: yup
      .string()
      .nullable()
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),
    info_contacts: yup.array().of(
      yup.object().shape({
        contact_address: yup.string().nullable(),
        contact_name: yup.string().nullable(),
        contact_phone: yup
          .string()
          .nullable()
          .matches(
            getPhoneValidation(t).regex,
            getPhoneValidation(t).errorMessage
          )
          .when(getPhoneValidation(t).when),
      })
    ),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
    control,
    setValue,
    getValues,
    setError,
    register,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: getInitDefaultValues(),
  });

  const { append: appendInfoContact } = useFieldArray({
    control: control, // control props comes from useForm (optional: if you are using FormContext)
    name: `info_contacts`, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  // Locations By Customer
  const onSuccessLocationsByCustomer = data => {
    const { items } = data;
    if (items?.length > 0) {
      const infoContactList = [];
      items.forEach(item => {
        const infoContact = {
          contact_address: item.fullAddress || "",
          contact_name: item.contact_name || "",
          contact_phone: item.contact_phone || "",
        };
        infoContactList.push(infoContact);
      });

      if (infoContactList.length > 0) {
        appendInfoContact(infoContactList);
      }
    }
  };
  const {
    // data: locationsByCustomerData,
    refetch: fetchLocationsByCustomer,
    remove: resetLocationsByCustomer,
  } = useLocationsByCustomer(
    {
      customerId: dataDetail?.customerId,
    },
    onSuccessLocationsByCustomer
  );

  // Detail Customer
  const onSuccessDetailCustomer = data => {
    reset(getInitDefaultValues());
    switch (mode) {
      case customerModeList.VIEW_CUSTOMER_DETAIL:
        setValue("name", data.name);
        setValue("code", data.code);
        setValue("phone", data.phone || "");
        setValue("mail", data.mail || "");
        setValue("note", data.note || "");
        setValue("source", data.source || "");
        setValue("is_noted", Boolean(data.is_noted));

        setControlFields({
          display: {
            ...getInitControlFields().display,
            name: true,
            code: true,
            phone: true,
            mail: true,
            note: true,
            source: true,
            is_noted: true,
          },
          disabled: {
            ...getInitControlFields().disabled,
            name: true,
            code: true,
            phone: true,
            mail: true,
            note: true,
            is_noted: true,
          },
        });
        break;
      case customerModeList.EDIT_CUSTOMER_DETAIL:
        setValue("name", data.name, { shouldValidate: true });
        setValue("code", data.code, { shouldValidate: true });
        setValue("phone", data.phone || "", { shouldValidate: true });
        setValue("mail", data.mail || "", { shouldValidate: true });
        setValue("note", data.note || "", { shouldValidate: true });
        setValue("source", data.source || "", { shouldValidate: false });
        setValue("is_noted", Boolean(data.is_noted), { shouldValidate: false });

        setControlFields({
          display: {
            ...getInitControlFields().display,
            name: true,
            code: true,
            phone: true,
            mail: true,
            note: true,
            source: true,
            is_noted: true,
            btn_save: true,
          },
          disabled: {
            ...getInitControlFields().disabled,
            code: true,
            name: true,
          },
        });
        break;
      default:
        break;
    }
  };
  const {
    isLoading: isLoadingDetail,
    data: customerDetail,
    refetch: detailCustomer,
    remove: resetDetailCustomer,
  } = useDetailCustomer(
    { customerId: dataDetail?.customerId },
    onSuccessDetailCustomer
  );

  // Update Customer
  const onSuccessUpdateCustomer = _data => {
    toggleModal(mode);
  };
  const onErrorUpdateCustomer = error => {
    if (error.code === 422 && error.fields.length > 0) {
      error.fields.forEach(item => {
        let fieldName = item.field;
        switch (item.field) {
          case "common":
            addToast(item.message, {
              appearance: "error",
              autoDismiss: true,
            });
            break;
          default:
            break;
        }
        setError(fieldName, {
          type: "manual",
          message: formConvertErrorMessage(item.message, t),
        });
      });
    }
    if (error.code !== 422) {
      toggleModal(mode);
    }
  };
  const { isLoading: isLoadingUpdate, mutate: updateCustomer } =
    useUpdateCustomer(onSuccessUpdateCustomer, onErrorUpdateCustomer);

  useEffect(() => {
    if (!isOpenModal) {
      resetDetailCustomer();
      resetLocationsByCustomer();
      setIsDetail(false);
      setControlFields(getInitControlFields());
      reset(getInitDefaultValues());
    }
  }, [isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && dataDetail.customerId && !isDetail) {
        detailCustomer();
        fetchLocationsByCustomer();
        setIsDetail(true);
      }
    }
  }, [dataDetail, detailCustomer, isDetail, isOpenModal]);

  const onSubmit = values => {
    const data = getValues();

    switch (mode) {
      case customerModeList.EDIT_CUSTOMER_DETAIL:
        updateCustomer({
          customerId: customerDetail?.id,
          data: {
            name: data.name,
            code: data.code,
            phone: data.phone,
            mail: data.mail,
            note: data.note,
            is_noted: data.is_noted ? 1 : 0,
          },
        });
        break;
      default:
        break;
    }
  };

  const is_noted = watch("is_noted");

  const handleChangeIsNoted = value => {
    setValue("is_noted", value);
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        style={{ maxWidth: "90vw" }}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <ModalHeader toggle={toggleModal}>
          {mode === customerModeList.VIEW_CUSTOMER_DETAIL &&
            `${t("title.detail")}`}
          {mode === customerModeList.EDIT_CUSTOMER_DETAIL &&
            `${t("title.edit")}`}
        </ModalHeader>
        {isLoadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="6"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <Row className="row-cols-1 row-cols-md-2">
                {controlFields.display.code && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="code">
                        {t("form.code")} <span className="text-danger">*</span>
                      </Label>
                      <input
                        disabled={controlFields.disabled.code}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "code"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.code"),
                        })}
                        {...register("code")}
                      />
                      {errors.code && (
                        <MessageFormValidate error={errors.code.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.name && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="name">
                        {t("form.name")} <span className="text-danger">*</span>
                      </Label>
                      <input
                        disabled={controlFields.disabled.name}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "name"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.name"),
                        })}
                        {...register("name")}
                      />
                      {errors.name && (
                        <MessageFormValidate error={errors.name.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.phone && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="phone">{t("form.phone")}</Label>
                      <input
                        disabled={controlFields.disabled.phone}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "phone"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.phone"),
                        })}
                        {...register("phone")}
                      />
                      {errors.phone && (
                        <MessageFormValidate error={errors.phone.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.mail && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="mail">{t("form.mail")}</Label>
                      <input
                        disabled={controlFields.disabled.mail}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "mail"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.mail"),
                        })}
                        {...register("mail")}
                      />
                      {errors.mail && (
                        <MessageFormValidate error={errors.mail.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.note && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="note">{t("form.note")}</Label>
                      <input
                        disabled={controlFields.disabled.note}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "note"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.note"),
                        })}
                        {...register("note")}
                      />
                      {errors.note && (
                        <MessageFormValidate error={errors.note.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}
                {controlFields.display.source && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="source">{t("form.source")}</Label>
                      <input
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "source"
                        )}`}
                        {...register("source")}
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                )}
                {controlFields.display.is_noted && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Switch
                        className="mx-1"
                        checked={is_noted}
                        onChange={handleChangeIsNoted}
                        disabled={controlFields.disabled.is_noted}
                      />
                      <Label className="mx-2" htmlFor="is_noted">
                        {t("form.is_noted")}
                      </Label>
                    </FormGroup>
                  </Col>
                )}
                <Col>
                  <FormGroup className="mb-3">
                    <Label htmlFor="is_noted">Mã chưa sử dụng</Label>
                    <div
                      className="d-flex align-items-center"
                      onClick={() => handleViewCodeUse(customerDetail)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex gap-1">
                        <div className="text-success fw-bold">
                          {customerDetail?.unworn_qty}
                        </div>
                        /
                        <div className="text-info">
                          {customerDetail?.total_qty}
                        </div>
                      </div>
                      <Button title="Xem chi tiết" color="link">
                        <i className="fas fa-solid fa-list-ul"></i>
                      </Button>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="row-cols-1">
                <Col>
                  <CustomerLocationTab customerId={dataDetail?.customerId} />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Row className="justify-content-end">
                {controlFields.display.btn_save && (
                  <Col className="col-auto">
                    <Button
                      color="primary"
                      className="btn-label"
                      type="button"
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                      disabled={isLoadingUpdate}
                    >
                      <i className="bx bx-save label-icon"></i>
                      {t("form.update")}
                    </Button>
                  </Col>
                )}
              </Row>
            </ModalFooter>
          </React.Fragment>
        )}
      </Modal>
    </React.Fragment>
  );
};

DetailCustomer.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleViewCodeUse: PropTypes.func,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
};

DetailCustomer.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
};

export default DetailCustomer;
